// extracted by mini-css-extract-plugin
module.exports = {"hero":"index-module--hero--2mwIu","heroTitle":"index-module--heroTitle--3kQrk","heroImg":"index-module--heroImg--2Ymxj"};